import { RegisterResponse } from '../../../../../types/api/endpoints/auth/register.types';
import { api } from '../../../../../utils/api/api';
import { CONSULTATIONS_ENDPOINTS } from '../../../../../utils/api/endpoints/consultationsEndpoints';

const PREFIX = '[sendDevisQuery]';

export const SEND_DEVIS_QUERY_KEY = 'SEND_DEVIS';

export const sendDevisQuery = async (data: FormData) => {
  console.log(PREFIX, `Requesting devis uploading...`);

  const response = await CONSULTATIONS_ENDPOINTS.sendDevis(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received devis.`);
  return json as RegisterResponse;
};

const UPDATE_PREFIX = '[updateDevisQuery]';

export const UPDATE_DEVIS_QUERY_KEY = 'UPDATE_DEVIS';

export const updateDevisQuery = async (data: FormData) => {
  console.log(UPDATE_PREFIX, `Requesting devis uploading...`);

  const response = await CONSULTATIONS_ENDPOINTS.updateDevis(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(UPDATE_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(UPDATE_PREFIX, `Received devis.`);
  return json as RegisterResponse;
};

export const downloadDevisENT = async (consultationId: number, consultationMatchId: number) => {
  const response = await api.get(
    `consultations/download/devis?consultationId=${consultationId}&consultationMatchId=${consultationMatchId}`,
    {},
    {
      responseType: 'blob',
      method: 'GET',
    }
  );

  const { ok, data } = response;

  if (!ok) {
    const error = response.data;
    console.log('An error occurred.', error);
    throw error;
  }

  // @ts-ignore
  const href = URL.createObjectURL(data);

  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', 'Devis.pdf');
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};
